export const configStaffAreas = [
	{
		"id": "04fc1950-bf3e-4d41-84ad-b248f6cf2336",
		"displayName": "tl9_timaru",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "066fe9f5-e529-403d-afcd-b4e2c7d9f2b7",
		"displayName": "tl9_dunedin",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "074822ae-8214-48b3-8a40-1b9ae12accb8",
		"displayName": "tl4_thames",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "056914a8-a189-491d-83d7-d0f3040cf2f7",
		"displayName": "tl1_auckland_center",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "3196c9c9-d664-4abd-b779-96bbf4407d8a",
		"displayName": "tl4_tauranga",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "32037d7f-5ad2-47bc-b1ef-6c848a8235f1",
		"displayName": "tl7_palmerston_north",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "3399b504-722b-4885-a98a-bf2b840b46d5",
		"displayName": "tl9_renwick",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "3471d4c5-7877-4b1a-9e13-45dd6d888a7b",
	// 	"displayName": "tl5_kawerau",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "39e65cb6-497e-4181-a78d-be28bc971894",
		"displayName": "tl4_hamilton",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "3cad1907-27dd-48c8-8ecc-45904b3b156d",
	// 	"displayName": "tl5_hawera",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "435043b4-23c9-4623-b141-e946882cc7b0",
		"displayName": "tl5_whakatane",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "45181fd5-7797-410d-8b92-ed4262fcc911",
		"displayName": "tl4_tokoroa",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "4b4df3ab-c907-41c8-af35-c7a906f0b13a",
		"displayName": "tl5_taupo",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "4cdd2104-313c-4349-8180-889718a5a936",
		"displayName": "tl1_kerikeri",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "4ee35f0a-226d-40a9-bd1d-3cbbe73921fa",
		"displayName": "tl1_whangarei",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "5789265b-3e2a-436d-94fd-b6310fd753ba",
		"displayName": "tl8_ashburton",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "5d2cd7fa-0ec9-4081-8842-f246d36c00b0",
	// 	"displayName": "tl6_waipukurau",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "bc280922-3b4c-454d-8d3c-3cd8c75abdba",
		"displayName": "tl7_dannevirke",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "64a0dc43-dff4-40c9-beb6-51f4ec1a040c",
		"displayName": "tl7_wellington",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "6b524d09-77bb-4fa3-97b0-021bf0d0d680",
		"displayName": "tl6_gisborne",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "750d3f0e-0fd8-4e82-b276-08690e713cf2",
		"displayName": "tl7_whanganui",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "787a6762-659b-41d9-8ecd-1de76bb7c26e",
		"displayName": "tl7_levin",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "837310da-d849-464a-9189-e2f5ac03e630",
		"displayName": "tl7_masterton",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "9b49bb17-ea9f-40f2-8f7c-bb7e34e5ea08",
	// 	"displayName": "tl7_waikanae",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "a4e33bf1-13e3-422e-8b9f-d1d6a68749c5",
		"displayName": "tl9_invercargill",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "ab56e3f1-8746-4bcb-b934-6a1d9a0763bb",
		"displayName": "tl6_napier",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "bc280922-3b4c-454d-8d3c-3cd8c75abdba",
	// 	"displayName": "tl7_dannevirke",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "bfd5873a-0017-446b-9d45-b27c84f81d27",
		"displayName": "tl9_greymouth",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "c660c43e-1aff-4e19-bb87-5a53210f41aa",
		"displayName": "tl4_new plymouth",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "cebd436c-4b93-4453-8ead-101c76ef7b68",
		"displayName": "tl6_hastings",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "d141dfdc-3b70-4841-a9d4-1e4131d6f912",
		"displayName": "tl9_nelson",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "d3b0f98e-99e1-4bc2-b40c-44deeed1cd3b",
		"displayName": "tl9_westport",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	// {
	// 	"id": "d4ccf2ae-7876-415f-b978-d38ff6fd40c1",
	// 	"displayName": "tl5_taumarunui",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "e08f5ff2-6c7e-41db-aaeb-1d9954937788",
		"displayName": "tl8_christchurch",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "e885d14c-f25c-4dab-857c-614689cb382b",
		"displayName": "tl1_kaitaia",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "f0356d34-3ceb-44b2-84b5-5d1ac9060424",
		"displayName": "tl5_rotorua",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "f9e82820-f348-4a13-bd9a-a7f6329faa75",
		"displayName": "tl5_new plymouth",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "fb1b49fa-92cc-4488-9949-f7c0a7e04286",
		"displayName": "tl9_oamaru",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "fec9787a-fa25-4302-aab5-b30406c3150a",
		"displayName": "tl5_whanganui",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "8f204c1d-ee09-4a6e-8332-d735b7ac590b",
		"displayName": "tl9_gore",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "210be210-c99e-4e49-8bd8-d01cf48ef9c7",
		"displayName": "tl9_centralotago",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "166344ff-8b24-486e-aacd-acd625a4619f",
		"displayName": "tl9_westcoast",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "7e340ec4-fb7f-4e98-8d7b-26f1cbbc4a85",
		"displayName": "tl1_hobsonville",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	}
];